import { CatalogProduct, ProductListViewedEvent, ProductSelectedEvent } from '../../../catalog/CatalogPageEvents';
import type { StoreState } from '../../../StoreState';
import { IEventAggregator } from '../../EventAggregator';
import { Analytics } from '../Analytics';
import { AnalyticsLists } from '../AnalyticsLists';
import { ProductDataConverter } from '../converters/ProductDataConverter';
import { ProductData } from '../types';

export class CatalogAnalyticsListener {
  constructor(
    eventAggregator: IEventAggregator,
    private readonly getStore: () => StoreState,
  ) {
    eventAggregator.subscribe(ProductListViewedEvent, (e) => this.onProductListViewed(e));
    eventAggregator.subscribe(ProductSelectedEvent, (e) => this.onProductSelected(e));
  }

  private onProductListViewed(e: ProductListViewedEvent) {
    const listName = AnalyticsLists.productCatalog(e.storeContext.store.displayName);

    Analytics.trackViewProductList({
      currency: e.storeContext.currency.code,
      listName,
      products: e.products.map((product, index) => this.toProductData(product, listName, e.startIndex + index + 1)),
    });
  }

  private onProductSelected(e: ProductSelectedEvent) {
    const listName = AnalyticsLists.productCatalog(e.storeContext.store.displayName);

    Analytics.trackSelectProduct({
      currency: e.storeContext.currency.code,
      listName,
      product: this.toProductData(e.product, listName, e.startIndex + e.index + 1),
    });
  }

  private toProductData({ family, model }: CatalogProduct, listName: string, listPosition: number): ProductData {
    if (!model) {
      return ProductDataConverter.fromProductFamilyBasicData(family, listName, listPosition);
    }

    const canBePurchased = this.getStore().canBePurchased({
      // The catalog lists only products available in the current store
      availableInCurrentStore: true,
      brandId: family.brandId,
      brandName: family.brand,
      canBePurchased: model.canBePurchased,
    });

    return ProductDataConverter.fromBaseModelLiteData(family, model, canBePurchased, listName, listPosition);
  }
}
